import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, takeUntil, Observable, AsyncSubject } from 'rxjs';
import { ToastService } from 'src/app/core/toast/toast.service';
import { BaseResponse } from 'src/app/model/response/base-response';
import { GlobalService } from 'src/app/services/global.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { environment } from 'src/environments/environment';
import { UserSettingsRequest, SelectedFiles } from '../settings';
import { SettingsComponent } from '../settings.component';
import { SettingsService } from '../settings.service';

@Component({
  selector: 'app-settings-style',
  templateUrl: './settings-style.component.html',
  styleUrl: './settings-style.component.scss'
})
export class SettingsStyleComponent implements OnInit, OnDestroy {

  themeSelected: string = ''; 
  @Output() isDark: boolean = false; 
  
  private theEnd$ = new Subject<void>();

  logoBase64?: string;
  imgPath: string = `${environment.baseHREF}${environment.logo}`;

  showOk: boolean = false;

  constructor(
    private globalService: GlobalService, 
    private toastService: ToastService, 
    private localStorageS: LocalStorageService, 
    private settingsService: SettingsService,
    private root: SettingsComponent,
  ) {
    
  }

  ngOnInit(): void {
    this.themeSelected = this.localStorageS.getAppTheme();
    this.isDark = this.globalService.isDark();
    if(this.root.globalSettings != undefined) {
      //this.logoBase64 = this.root.globalSettings.customLogoPath;
    }
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  switchTheme(theme?:boolean){
    if(theme != undefined){
      this.globalService.dark(theme);
      this.localStorageS.setAppTheme(theme ? 'dark' : 'light')
    }else{
      this.globalService.dark(this.globalService.isDark());
      this.localStorageS.setAppTheme('system')
    }

    this.themeSelected = this.localStorageS.getAppTheme();
    this.isDark = this.globalService.isDark();
  }


  saveImage() {

    if(this.loadLogoToBase64 == undefined) {
      this.toastService.GenerateToast({
        title: 'Caricamento immagine in corso',
        content: 'Riprova tra qualche secondo',
        severity: 'e-toast-danger'
      });
      return;
    }

    let req: UserSettingsRequest = {
      ImageBase64: this.logoBase64 ?? '',
    }

    /*this.settingsService.SaveImgage(req).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: BaseResponse) => {
        if(res.success == false) {
          this.toastService.GenerateToast({
            title: 'Errore durante la modifica',
            content: res.error,
            severity: 'e-toast-danger'
          });
        }else{
          this.toastService.GenerateToast({
            title: 'Immagine caricata correttamente',
            content: '',
            severity: 'e-toast-success'
          });
          // save it in localStorage
          this.localStorageS.addValue('USCL', this.logoBase64);
        }
      },
      error: (res: BaseResponse | null | undefined) => {

        if(res == null || res == undefined) {
          this.toastService.GenerateToast({
            title: 'Errore durante la modifica',
            content: 'riprova più tardi',
            severity: 'e-toast-danger'
          });
          return;
        }

        try{
          if('success' in res) {
            this.toastService.GenerateToast({
              title: 'Errore durante la modifica',
              content: res.error,
              severity: 'e-toast-danger'
            });
          }else{
            this.toastService.GenerateToast({
              title: 'Errore durante la modifica',
              content: 'riprova più tardi',
              severity: 'e-toast-danger'
            });
          }
        }catch{
          this.toastService.GenerateToast({
            title: 'Errore durante la modifica',
            content: 'riprova più tardi',
            severity: 'e-toast-danger'
          });
        }        

      }
    });*/

  }

  loadLogoToBase64(event: any) {

    this.toFilesBase64(event.srcElement.files).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (resp: SelectedFiles) => {
        this.logoBase64 = resp.base64;
        this.showOk = true;
      }
    })

  }


  
  //Convert file to base64
  public toFilesBase64(files: File[]): Observable<SelectedFiles> {
    const result = new AsyncSubject<SelectedFiles>();
    if (files?.length) {
      Object.keys(files)?.forEach(async (file, i) => {
        const reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = (e) => {

          var selectedFiles = { name: files[i]?.name, file: files[i], base64: reader?.result as string };
          result.next(selectedFiles);
          if (files?.length === (i + 1)) {
            result.complete();
          }
        };
      });
      return result;
    } else {
      result.complete();
      return result;
    }
  }

}
